import { makeStyles } from '@material-ui/core/styles';
import FiggersBYOD from '../../assets/img/new images/figgersBYOD.svg';

export default makeStyles(theme => ({
    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        padding: "0 10px",
        height: '58px',
        "& h2": {
            padding: '0px 0px',
            // fontSize: '22px',
            // fontWeight: 600,
            // lineHeight: '28.8px',
            // color: '#2D4D95',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 600,
             fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
            lineHeight: '29px',
            color: '#2D4D95',
        }
    },
    isDisabled: {
        opacity: 0,
    },
    changeLink: {
        display: 'inline-block',
        float: 'right',
        color: '#0686D8',
        fontFamily: 'Lato',
        fontWeight: 400,
        fontSize: '14px',
        cursor: 'pointer',
        marginLeft: 'auto',
        position: 'relative',
        top: '-6px',
        right: '-12px',
    },
    addressEmptyBox: {
        width: '45px',
        display: 'flex',
        margin: 'auto',
    },
    accountHomeTitle: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: window.isMobileView? '14px':'18px',
        lineHeight: '16px',
        display: 'flex',
        alignItems: 'center',
        marginBottom:'10px',
    },
    
    container: {
        padding: '10px',
        background: window.isIpadView ? 'white' : '',
    },
    mobAccountInformation: {
        backgroundColor: '#D6E9FF',
        padding: '15px 15px 40px 15px',
        width: '100%',
        borderRadius: '15px',
        margin: '0px 0px 15px 0px',
        position: 'relative',
        "& h2": {
            color: '#0049A3',
            fontWeight: 600,
            fontSize: window.isMobileView? '16px' : '24px',
            margin: 0,
        },
        "& p": {
            fontSize: '14px',
            lineHeight: '17px',
            textDecorationLine: 'underline',
            color: '#0049A3',
            marginBottom: '5px',
        }
    },
    mobUserAccound: {
        '& p': {
            fontSize: '16px',
            margin: 0,
            fontWeight: '700',
        }
    },
    rechargeBtn: {
        color: '#ffffff',
        bottom: '-13px',
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',
        position: 'absolute',
        textTransform: 'capitalize',
        backgroundColor: '#0049A3',
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        borderRadius: '4px',
        marginRight: '5px',
        lineHeight: '16px',
        fontWeight: 600,
        cursor: 'pointer',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },

  
    accountPaperCollapse: {
        width: "100%",
        // height: '350px',
        background: '#FFFFFF',
        boxShadow: 'inset 0px -1px 0px #E8E9E9',
        borderRadius: '8px',
        // transform: 'matrix(1, 0, 0, -1, 0, 0)',
    },

    accountPaper: {
        padding: '15px',
        '@media (max-width: 780px)': {
            padding: '10px',
        },
    },
    accountCardHeader: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '10px',
        justifyContent: 'space-between',
        borderBottom: '1px solid #F1F1F1'
    },
    accountCardHeaderTitle: {
        display: "flex",
        alignItems: "baseline"
    },

    accountCardTitle: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '18px',
        lineHeight: '24px',
        color: '#3C4549',
        marginRight: '10px',
        padding: '9px 0px',
    },
    accountCardMember: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '17px',
        color: '#3C4549',
        // margin: '0 10px'
    },
    accountCardOrganisationName: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#848789',
        textTransform: 'capitalize',
    },
    closeButton: {
        width: "25px",
        minWidth: "25px",
        height: "25px",
        borderRadius: "5px",
        margin: 0,
        color: "#11284B",
        backgroundColor: "#F9F9F9",
        boxSizing: "border-box",
        fontSize: 15,
        fontFamily: "Lato",
        textTransform: "none",
        padding: "0 12px",
        marginLeft: 19,
        border: "1px solid #2D4D95",
        '&:hover': {
            backgroundColor: "#2D4D95",
            color: "white",
        },
        newAddBtnLink: {
            color: "white",
        },
        "& .MuiButton-startIcon": {
            marginRight: 0,
            "& .MuiSvgIcon-root": {
                width: 22,
                height: 22
            }
        }
    },
    flexBtn: {
        display: 'flex',
        alignItems: 'center',
    },
    expiryBtn: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        lineHeight: '16px',
        padding: '10px 15px',
        background: 'rgba(254, 152, 0, 0.3)',
        border: '1px solid #B16B01',
        borderRadius: 10,
    },
    accountCardContainer: {
        padding: '10px 0',
        display: 'flex',
        justifyContent: 'space-between',
    },
    accountSection: {
        padding: '13px 20px 13px 10px',
        background: '#f9f9f9',
        borderRadius: '15px',
        minWidth: '350px',
    },
    accountSubCardSection: {
        display: "flex",
        gap: '10px',
        flexFlow: 'wrap',
        justifyContent: 'center',
        alignSelf: 'center',
        marginLeft : '25px',
              alignItems: 'stretch'
    },
    accountList: {
        margin: 0,
        padding: 0,
        // height: '73px',
        listStyle: 'none',
        "& li": {
            display: 'flex',
            padding: '4px 6px',
            '@media (max-width: 780px)': {
                flexFlow: 'wrap',
                borderBottom: '1px solid #ededed',
            },
        },
    },
    accountLabel: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        color: '#757575',
        minWidth: '170px',
        '@media (max-width: 780px)': {
            minWidth: '150px',
        },
    },
    accountHomeSection: {
        border: '1px solid #DFDFDF',
        borderRadius: '8px',
        padding: '13px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        minWidth: '270px',
        minHeight: '149px',
        "& span": {
            display: 'flex',
            justifyContent: 'space-between',
            "& img": {
                width: "20px",
                height: "20px",
                cusrsor: 'pointer'
            }
        },
        '@media (max-width: 1000px)': {
            width: '100%',
            marginTop: '9px',
        },
    },
    accountValue: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '16px',
        color: '#3C4549',
        textTransform: 'inherit',
    },
    accountValueTruncate: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: '#3C4549',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '200px',
    },
 
    accountHomeSubTitle: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '14px',
        color: '#000000',
        textTransform: 'capitalize',
    },
    accountHomeAddress: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        color: '#868686',
    },
    selectBaseInput: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 2px 5px 2px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '0px 8px 0px 0px',
        height: '35.63px',
        borderRadius: '4px',
        border: '1px solid #bebebe',
        borderRadius: '10px',


        "& .MuiInputBase-input": {
            padding: "0px 24px 0px 12px",
            minHeight: "35.63px",
            fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
            color: "black",
            fontFamily: 'Lato',
            fontWeight: 'bolder',
            '&:focus': {
                background: 'transparent',
                borderRadius: "4px",
                outline: 0,
            },
            "&:before": {
                borderBottom: 'none !important',
            },
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'none'
        },

        "& .Mui-disabled": {
            backgroundColor: "#f3f3f3",
            color: "#4A4A4A"
        },
        "& input::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input[type=number]": {
            appearance: "textfield"
        },
    },
    accountBillingSection: {
        border: '1px solid #DFDFDF',
        borderRadius: '8px',
        padding: '13px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        minHeight: '149px',
        minWidth: '270px',
        "& span": {
            display: "flex",
            justifyContent: "space-between",
            "& img": {
                width: "20px",
                height: "20px",
                cursor: 'pointer'
            }
        },
        '@media (max-width: 1000px)': {
            width: '100%',
            marginTop: '9px',
        },
    },
    pageTitle: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
         fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
        lineHeight: '29px',
        color: '#2D4D95',
    },
    showMore: {
        color: '#0049A3',
        display: 'inline-block',
        borderRadius: '5px',
        padding: '3px',
        fontSize: '15px',
        cursor: 'pointer',
    },
    mobAccountDetails: {
        fontSize: '15px',
        color: '#3C4549',
        lineHeight: 'initial',
        display: 'flex',
        lineHeight: '15px',
        "& img": {
            marginRight: '10px',
        }
    },
    usagePaper: {
        margin: '10px 0',
        padding: '15px',
        background: '#FFFFFF',
        boxShadow: 'inset 0px -1px 0px #E8E9E9',
        borderRadius: '8px',
        "& .paperTitle": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: 20,
            lineHeight: '24px',
            color: '#3C4549',
        },
        "& .paperTime": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: 14,
            lineHeight: '18px',
            color: '#3C4549',
            textAlign: "right !important"
        },
    },
    cardContainer: {
        width: "100%",
        display: 'flex',
        gap: '10px',
        position: 'relative',
    },
    sectionHeading: {
        fontSize: window.isMobileView ? '18px':'22px',
        fontWeight: '600',
        margin: '10px 0',
    },
    accountType: {
        border: '1px solid #bebebe',
        padding: '5px 15px',
        borderRadius: '50px',
        background: '#ffffff',
        margin: 0,
    },
    floatRight: {
        marginLeft: 'auto',
     },
    chartTop: {
        display: window.isMobileView ?'block':'flex',
        textAlign: window.isMobileView ?'center': 'initial',
        alignItems: 'baseline',
        fontSize: window.isMobileView ? '12px' : '',
        marginBottom: window.isMobileView ? '15px': 'initial',
        
    },

    usageCard: {
        display: 'flex',
        height: window.isIpadView ? '168px' : '250px',
        width: window.isIpadView ? '168px' : '',
        flexDirection: 'column',
        justifyContent: "center",
        alignItems: 'center',
        padding: "15px",
        margin: 'auto',
        background: '#FFFFFF',
        border: '1px solid #E4E2E2',
        borderRadius: window.isIpadView ? '50%' : '20px',
        boxShadow: 'none',
        position: 'relative',
        "& img": {
            width: window.isIpadView ? "40px" : "40px",
            height: window.isIpadView ? "40px" : "40px",
        },
        "& .cardCount": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: window.isIpadView ? '30px' : '48px',
            lineHeight: window.isIpadView ? '' : '58px',
            textAlign: 'center',
            color: '#000000',
        },
        "& .cardUnit": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: 18,
            lineHeight: '22px',
            textAlign: 'center',
            color: '#757575',
        },
        "& .cardUsage": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: window.isIpadView ? '15px' : '22px',
            lineHeight: window.isIpadView ? 'initial' : '35px',
            textAlign: 'center',
            color: '#757575',
        },
        "& .cardTitle": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: window.isIpadView ? '14px' : '24px',
            lineHeight: '29px',
            textAlign: 'center',
            color: '#000000',
            maxWidth: window.isMobileView ? '75px' : '',
        },

    },
    accountAddress: {
        textTransform: 'capitalize',
        lineHeight: 'initial',
    },
    column1: {
        order: window.isIpadView ? 2 : 1,
        "& .recharts-cartesian-axis": {
            display:window.isMobileView ? 'none': 'initial',
        }
    },

    column2: {
        order: window.isIpadView ? 1 : 2,
    },
    offersContainer: {
        border: '1px solid #e4e2e2',
        background: 'white',
        borderRadius: '15px',
        marginTop: '8px',
        "& .paperTitle": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: 20,
            lineHeight: '24px',
            color: '#3C4549',
            padding: '15px 0px 0px 15px',
        },
    },
    figgersContainer: {
        width: "100%",
        display: 'flex',
        flexFlow: 'wrap',
        justifyContent: "space-evenly",
        gap: '10px',
        margin: window.isIpadView?'20px 0 100px 0'  :'20px 0',
        "& img": {
            width: '460px',
            objectFit: 'contain',
            background: 'none',
            padding: 0,
            height: 'unset',
            '@media (min-width: 1800px)': {
                width: '490px'
            },
            '@media (max-width: 1600px)': {
                width: '364px'
            },
            '@media (max-width: 1396)': {
                width: '350px'
            }
        },
        "& .figgersCardTitle": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: window.isMobileView ? '20px' : '30px',
            lineHeight: window.isMobileView ? 'initial': '30px',
            color: '#FFFFFF',
        },
        "& .figgersCardDesc": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: window.isMobileView ? 15: 18,
            lineHeight: window.isMobileView ? 'initial': '21px',
            color: '#FFFFFF',
        }
    },
    figgersEligibleCard: {
        display: "flex",
        alignItems: 'center',
        width: window.isIpadView ? '100%': '32%',
        height: '175px',
        padding: "20px",
        borderRadius: "15px",
        backgroundColor: '#0049A3',
        cursor: 'pointer',
    },
    figgersOfferImage: {
        display: "flex",
        alignItems: 'center',
        width: window.isIpadView ? '100%' : '32%',
        height: '175px',
    },
    figgersACPCard: {
        display: "flex",
        alignItems: 'center',
        width: '32%',
        height: '175px',
        padding: "20px",
        borderRadius: "15px",
        // backgroundColor: 'linear-gradient(97.4deg, #0049A3 44.99%, rgba(0, 73, 163, 0) 102.87%)',
        backgroundColor: "linear-gradient(97.4deg, #0049A3 44.99%, rgba(0, 73, 163, 0) 102.87%)",
        background: "linear-gradient(97.4deg, #0049A3 44.99%, rgba(0, 73, 163, 0) 102.87%)"
    },
    figgersBYODCard: {
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'center',
        width: '32%',
        height: '175px',
        padding: "20px",
        borderRadius: "15px",
        backgroundImage: `url(${FiggersBYOD})`,
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        // backgroundSize:"contain",
        backgroundRepeat: 'no-repeat',
        // background: "url(../../assets/img/new images/figgersBYOD.svg)",
    },
    digitalServicePaper: {
        margin: '10px 0',
        padding: '15px',
        background: '#FFFFFF',
        boxShadow: 'inset 0px -1px 0px #E8E9E9',
        borderRadius: '8px',
        "& .paperTitle": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: 20,
            lineHeight: '24px',
            color: '#3C4549',
        },
    },
    digitalCardContainer: {
        width: "100%",
        display: 'flex',
        gap: '10px',
        marginTop: '20px',
        flexFlow: window.isIpadView ? 'wrap' : '',
        justifyContent: 'space-around',
    },
    digitalServiceCard: {
        display: 'flex',
        gap: '5px',
        // width: "300px",
        // height: '250px',
        flexDirection: 'column',
        justifyContent: "center",
        alignItems: 'center',
        padding: "15px",
        // background: '#FFFFFF',
        // border: '1px solid #E4E2E2',
        borderRadius: '9px',
        cursor: 'pointer',
        border: '1px solid transparent',
      
        "& img": {
            width: "40px",
            height: "40px",
        },
        "& .cardTitle": {
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: 16,
            lineHeight: '19px',
            textAlign: 'center',
            color: '#3C4549',
        },
        '&:hover': {
            background: '#f2f2f2',
            border: '1px solid #E4E2E2',
        },
    },
    viewAllButtonDisable: {
        opacity:0.6,
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: window.isMobileView ? window.isMobile425 ? '8px' : '10px' : '14px',
        color: '#0049A3',
        lineHeight: '16px',
        textTransform: 'none',
        padding: '8px 15px 8px 10px',
        border: '1px solid #0049A3',
        borderRadius: 4,
        cursor: 'not-allowed',
        // marginLeft: 'auto',
        marginTop: "0px",
        "& :hover": {
          
        },
    },
    viewAllButton: {
        
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        color: '#0049A3',
        lineHeight: '16px',
        textTransform: 'none',
        padding: '8px 15px 8px 10px',
        border: '1px solid #0049A3',
        borderRadius: 4,
        // marginLeft: 'auto',
        marginTop: "0px",
        "& :hover": {
            cursor: 'pointer'
        },
    },
    ButtonImg:{
        margin: '0 !important'
    },
    rightContainer: {
        display: 'flex',
        alignItems: 'center',

        "& img": {
            cursor: 'pointer',
            marginLeft: window.isMobile425 ? '5px': '20px',
        }
    },
    rightContent: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        gap: '10px',
        justifyContent: window.isMobileView? 'center':'end',
        
        "& .MuiInputBase-root": {
            width: 'unset',
            height: '40.5px',
        }
    },

    internetSq: {
        backgroundColor: '#0049A3',
        width: '15px',
        height: '15px',
        margin: window.isMobileView ? '-2px 10px' : '-2px 10px',
        display: 'inline-block',
    },
    SMSSq: {
        backgroundColor: '#D47838',
        width: '15px',
        height: '15px',
        margin: '-2px 10px',
        display: 'inline-block',
    },
    CallSq: {
        backgroundColor: '#0686D8',
        width: '15px',
        height: '15px',
        margin: '-2px 10px',
        display: 'inline-block',
    },
    changeBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',

        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '6px',
        marginRight: '5px',
        
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',

        fontFamily: 'Lato',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        textWrap: 'nowrap',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    roamingSq: {
        backgroundColor: '#843C9F',
        width: '15px',
        height: '15px',
        margin: '-2px 10px',
        display: 'inline-block',
    },

    chartpaper: {
        boxShadow: 'none',
        border: '1px solid #e4e2e2',
        borderRadius: '15px',
        minHeight: window.isMobileView ? '410px' : '510px',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        flexFlow: 'column',
    },
    expiryDatePast: {
        background: "#FFDDDD !important",
        border: "1px solid #d3d3d3",
        boxShadow: "2px 2px 3px 1px #d6d3d375",
        padding: '5px 13px',
        marginRight: '8px',
        marginBottom: '5px',
        textTransform: 'capitalize',
        borderRadius: '10px',
        color: '#FF0000 !important',
        fontWeight: '600',
    },

    expiryDate: {
        border: '1px solid #3C4549',
        borderRadius: '10px',
        textTransform: 'capitalize',
        marginBottom: '5px',
        padding: '4px 13px',
        marginRight: '8px',
        background: 'rgba(254, 152, 0, 0.3)',
        "& :hover": {
            background: 'rgba(254, 152, 0, 0.3) !important',
        }
    },
    expiryDateRed: {
        background: '#FFB7B7 !important',
        border: '1px solid #DA0B0B !important',
    },
    expiryDateYellow: {
        background: 'rgba(255, 173, 50, 0.7) !important',
        border: '1px solid #FF9900 !important',
    },
    expiryDateGreen: {
        background: '#B5FEBC',
        border: '1px solid #10B921',
    },
    flexStart: {
        justifyContent: 'flex-start',
        display: 'flex',
    },
    // dashIcon:{
    //     maxWidth: window.isMobileView? '40px !important' : ''
    // },
    statusBoxContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        justifyItems: 'end',
        gap: '10px',
        "& .flowColumns":{
            flexFlow: 'column !important',
        },
        "& .Active": {
            background: '#DCFCE7',
            border: '1px solid transparent',
            "& h4": {
                color: '#10B921',
                marginBottom: '0',
            },
            "& h2": {
                color: '#10B921',
            },
        },
        "& .Mui-checked + span > .Active": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #10B921',
        },

        "& .Inactive": {
            background: '#EEEEEE',
            border: '1px solid transparent',
            "& h4": {
                color: '#9B9B9B',
                marginBottom: '0',
            },
            "& h2": {
                color: '#9B9B9B',
            },
        },
        "& .Mui-checked + span > .Inactive": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #9B9B9B',
        },

        "& .Suspended": {
            background: '#E2F1FF',
            border: '1px solid transparent',
            "& h4": {
                color: '#0686D8',
                marginBottom: '0',
            },
            "& h2": {
                color: '#0686D8',
            },
        },
        "& .Mui-checked + span > .Suspended": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #0686D8',
        },

        "& .Disconnected": {
            background: '#FCDCDC',
            border: '1px solid transparent',
            "& h4": {
                color: '#FF0000',
                marginBottom: '0',
            },
            "& h2": {
                color: '#FF0000',
            },
        },
        "& .Mui-checked + span > .Disconnected": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #FF0000',
        },

        "& .Hotline": {
            background: '#FBEEBC',
            border: '1px solid transparent',
            "& h4, h2": {
                color: '#FE9800',
            },
        },
        "& .Mui-checked + span > .Hotline": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #FE9800',
        },

        "& .Hotline": {
            background: '#FBEEBC',
            border: '1px solid transparent',
            "& h4, h2": {
                color: '#FE9800',
            },
        },
        "& .Mui-checked + span > .Hotline": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #FE9800',
        },

        "& .Rejected": {
            background: '#FFEDED',
            border: '1px solid transparent',
            "& h4, h2": {
                color: '#F56C6C',
            },
        },
        "& .Mui-checked + span > .Rejected": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #F56C6C',
        },

        "& .Port-In-Cancel": {
            background: '#843c9f30',
            border: '1px solid transparent',
            "& h4, h2": {
                color: '#843C9F',
            },
        },
        "& .Mui-checked + span > .Port-In-Cancel": {
            boxShadow: '0px 0px 5px 3px #00000021',
            border: '1px solid #843C9F',
        },


        "& .MuiCheckbox-colorPrimary": {
            position: 'absolute',
        }
    },
    checkBoxFormLabel: {
        margin: '0px 2px 5px 2px',
        width: window.isWidth1600? '':'50%'
    },
    checkBoxBtn: {
        marginLeft: "0px",
        paddingRight: "5px",
        "& + .MuiFormControlLabel-label": {
            color: "#52575C",
            fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        },
        "& .MuiSvgIcon-root": {
            opacity: 0,
            display: 'none',
        }
    },
    statusBoxContent: {
        "& h2": {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '27px',
            margin: 0,
            color: '#10B921',
        },
        "& h5": {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '13px',
            margin: 0,
            color: '#10B921',
        }
    },
    colourd_box_container: {
        "& .MuiGrid-root": {
            padding: '5px',
        }
    },
    colourd_box: {
        width: '100%',
        padding: '6px 6px',
        display: 'flex',
        flexFlow: 'column',
         justifyContent: 'center',
        alignItems: 'center',
        background: '#dddddd',
        margin: '0 4px',
        "& h3": {
            color: 'white',
            fontSize: '15px',
        },
        "& p": {
            color: 'white',
            fontSize: '18px',
            margin: '0',
            fontWeight: 'bold'
        }
    },
    PRofileTop:{
        position:'relative',
    },
    CoverImg: {
        border: '1px solid #e1e1e1',
        // padding: '10px',
        borderRadius: '20px',
        // margin: '7px',
        background: 'white',
    },
    CoverSec: {
       
    },

    coverImg: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '250px',
        maxHeight: '250px',
        background: 'gainsboro',
        borderRadius: '15px',
        position: 'relative',
        alignSelf: 'center',
        objectFit: 'cover',
        "& img": {
            objectFit: 'cover',
            objectPosition:'center',
            width:'100%',
            height:'250px',
            margin:'auto',
            padding:'5px',
            borderRadius: '15px',  
        }
    },
    whiteBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: window.isIpadView?'center' : 'left',
        marginTop: window.isMobileView ? '-120px' :'-180px',
        marginLeft:window.isIpadView? '':'25px',
        marginBottom:'20px'

    },
    profileImg: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: window.isMobileView ? '160px' :'200px',
        minWidth: window.isMobileView ? '160px' :'200px',
        background: '#ffffff',
        borderRadius: '15px',
        position: 'relative',
        alignSelf: 'center',
        objectFit: 'cover',
        border:'1px solid #bcbcbc',
        borderRadius:'10%',
        "& img": {
            position: 'absolute',
            maxWidth:window.isMobileView ? '160px' : '200px',
            width: '100%',
            borderRadius: '10%',
            margin: 'auto',
            left: 0,
            height: window.isMobileView ? '160px' : '200px',
            padding: '5px',
            objectFit:'cover'
        }
    },
    CoverEditICon: {
        width: '34px !important',
        padding: '9px',
        zIndex: 4,
        right: '2px !important',
        bottom: '2px !important',
        left: 'unset !important',
        background: '#0049a3',
        borderRadius: '16px !important',
        cursor: 'pointer',
        height: 'unset !important',
        padding: '6px !important',
        position:'absolute !important',
    },
    EditICon: {
        width: '34px !important',
        padding: '9px',
        zIndex: 4,
        right: '2px !important',
        bottom: '2px !important',
        left: 'unset !important',
        background: '#0049a3',
        borderRadius: '16px !important',
        cursor: 'pointer',
        height: 'unset !important',
        padding: '6px !important',
    },
}))